import asyncFetch from './async-fetch';
import { getBaseRequestConfig } from './baseRequestConfig';
import {underscoreToSpace} from "../helpers/helpers";


export async function updateSubmission(submission) {
    /* global API_BASE_URL */
    const url = API_BASE_URL + '/submissions/' + submission.id;

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "PUT";
    baseRequestConfig.body = JSON.stringify(submission);
    baseRequestConfig.headers['content-type'] = 'application/json';

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function createSubmission(data) {
    /* global API_BASE_URL */
    const url = API_BASE_URL + '/submissions';

    let baseRequestConfig = getBaseRequestConfig();
    baseRequestConfig.method = "POST";

    baseRequestConfig.body = JSON.stringify(data);
    baseRequestConfig.headers['content-type'] = 'application/json';

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function fetchDropboxUserSubmissions(dropboxId, userId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/dropboxes/${dropboxId}/users/${userId}/submissions`;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function fetchAssignmentSubmissions(assignmentId) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/assignments/${assignmentId}/submissions`;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}

export async function fetchDropboxAssignmentSubmission(dropboxName, assignmentName) {
    /* global API_BASE_URL */
    const url = `${API_BASE_URL}/submissions/search?dropbox=${dropboxName}&assignment=${underscoreToSpace(assignmentName)}`;

    const baseRequestConfig = getBaseRequestConfig();

    const response = await asyncFetch(url, baseRequestConfig);

    return await response.json();
}



/** WEBPACK FOOTER **
 ** ./src/connectivity/api.submissions.js
 **/